import { FC } from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { AngelInvestmentBanner } from '@/organisms/InvestmentBanner/AngelInvestmentBanner'
import { PageContent } from '@/page/PageContent/PageContent'
import { PageDataContext, PageModel } from '@/services/RenderService/types'

interface Props {
  page: Maybe<PageModel>
  pageDataContext: Maybe<PageDataContext>
}

export const Page: FC<Props> = ({ page, pageDataContext }) => {
  if (!page || !pageDataContext) return null

  return (
    <>
      {page.contentCollection?.items.map((content) => {
        if (!content || !content?.sys?.id) return null // this could be content that is not yet supported
        const key = `${content?.__typename}-${content?.sys?.id}`

        // The Angel Investment Banner's visibility is controlled via a feature flag, instead of Contentful.
        // It's temporary, and will be removed after the Angel Offering is closed.
        if (
          page.path === '/watch' &&
          content.__typename === 'CollectionDisplay' &&
          content.sys.id === '7Cwts1DFTHgjvDQjLPOuQG' // Top 10 Comedy Specials
        ) {
          return (
            <div key={key}>
              <PageContent content={content} pageDataContext={pageDataContext} />
              <AngelInvestmentBanner />
            </div>
          )
        }

        return <PageContent key={key} content={content} pageDataContext={pageDataContext} />
      })}
    </>
  )
}
